module.exports = __webpack_public_path__ + "img/beats.e9a0b702.png";